export const lifecycles = {
  INTERACTIVE_PRE_ENTRY: 'INTERACTIVE_PRE_ENTRY',
  INTERACTIVE_ENTRY: 'INTERACTIVE_ENTRY',
  INTERACTIVE_DURING: 'INTERACTIVE_DURING',
  INTERACTIVE_EXIT: 'INTERACTIVE_EXIT',
  INTERACTIVE_EVALUATE: 'INTERACTIVE_EVALUATE',
  INTERACTIVE_COMPLETE: 'INTERACTIVE_COMPLETE',
  ACTIVITY_ENTRY: 'ACTIVITY_ENTRY',
  ACTIVITY_START: 'ACTIVITY_START',
  ACTIVITY_COMPLETE: 'ACTIVITY_COMPLETE',
  ACTIVITY_EVALUATE: 'ACTIVITY_EVALUATE',
};

export const categories = {
  RECORDING: 'recording',
  RESPONSES: 'responses',
  VARIABLES: 'variables',
  OBJECTIVE: 'objective',
  PERFORMANCE: 'performance',
  DETAILS: 'details',
  BEHAVIOR: 'behavior',
  FEEDBACK: 'feedback',
  PROGRESS: 'progress',
  CHANGE_SCORE: 'CHANGE_SCORE',
  CHANGE: 'change',
  ALLRESPONSES: 'allResponses',
  CURRENTRESPONSES: 'currentResponses',
  GRADE_PASSBACK: 'GRADE_PASSBACK',
};

export const conditionTypes = {
  CHAINED_CONDITION: 'CHAINED_CONDITION',
  EVALUATOR: 'EVALUATOR',
};

export const actionTypes = {
  CHANGE_PROGRESS: 'CHANGE_PROGRESS',
  CHANGE_SCOPE: 'CHANGE_SCOPE',
  CHANGE_SCORE: 'CHANGE_SCORE',
  FEEDBACK: 'feedback',
  OBJECTIVE: 'objective',
  CHANGE: 'change',
  GRADE_PASSBACK: 'GRADE_PASSBACK',
};

export const resolverTypes = {
  LITERAL: 'LITERAL',
};

export const broadcastActions = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
};

export const progressionTypes = {
  INTERACTIVE_COMPLETE: 'INTERACTIVE_COMPLETE',
  INTERACTIVE_REPEAT: 'INTERACTIVE_REPEAT',
};

export const graphProgressionTypes = {
  INTERACTIVE_REPEAT: 'INTERACTIVE_REPEAT',
  INTERACTIVE_COMPLETE_AND_GO_TO: 'INTERACTIVE_COMPLETE_AND_GO_TO',
  ACTIVITY_REPEAT: 'ACTIVITY_REPEAT',
  ACTIVITY_COMPLETE_AND_GO_TO: 'ACTIVITY_COMPLETE_AND_GO_TO',
};
